import React, { createContext } from 'react';

const FilterContext = createContext();

const FilterProvider = ({ activeFilters, navigationCondition, applyNavigation, children }) => (
    <FilterContext.Provider value={{ activeFilters,
        navigationCondition,
        applyNavigation }}>
        {children}
    </FilterContext.Provider>
);

export {
    FilterProvider,
    FilterContext
};
